var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mag-header-exit",attrs:{"title":"Выйти"},on:{"click":_vm.logout}},[_c('i',{staticClass:"mag-icon-nav-top-exit"})])}
var staticRenderFns = []

export { render, staticRenderFns }